<template>
  <div class="mainledgerprint">

  </div>  
</template>

<script>
// import DocumentService from '@/services/DocumentService'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'

export default {
  name: 'mainledgerprintcard9',
  props: ['card'],
  data () {
    return {
      lang: {},
      langC: {},
      comp: {},
      docDefinition: {},
      content: [],
      items: [],
      striped: false,
      bordered: false,
      outlined: false,
      small: false,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      locCreatedAt: '',
      locUpdatedAt: '',
      order: 0,
      partner: {}
    }
  },
  mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = ledgerEN
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = ledgerHR
      this.langC = commHr
    }
    this.comp = this.$store.state.companyActiv ? this.$store.state.companyActiv : {}

  },
  methods: {
    async print () {

      await this.initDocument()
      await this.addHeaderNoLogo()
      await this.addLine()
      await this.addItemsHeader()
      await this.addLine()
      await this.addItems()
      await this.addItemsFoter()
      await this.addLine()
      this.docDefinition.content = this.content
      pdfMake.createPdf(this.docDefinition).open()
    },
    initDocument () {
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      this.docDefinition = {}
      this.docDefinition.pageSize = 'A4'
      this.docDefinition.pageOrientation = 'portrait'
      this.docDefinition.pageMargins = [ 20, 20, 20, 20 ]
      this.content = []
    },
    formatPrice (value) {
      if (this.$store.state.language === 'EN') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      if (this.$store.state.language === 'HR') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    addEmptyRow () {
      const docPart = {
            columns: [
              {
                width: '20%',
                text: [
                  { text: ' \n ', fontSize: 8 }
                ]
              },
              {
                width: '60%',
                text: [
                  { text: ' ', fontSize: 8 }
                ]
              }
            ]
          }
      this.content.push(docPart)
    },
    addLine () {
      const docPart = {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 550,
                y2: 0,
                lineWidth: 1
              }
            ]
          }
      this.content.push(docPart)
    },
    addLineDash () {
      const docPart = {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 550,
                y2: 0,
                lineWidth: 1,
                dash: { length: 1 },
              }
            ]
          }
      this.content.push(docPart)
    },
    addHeaderNoLogo () {
      const docPart = {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '35%',
                text: [
                  { text: this.comp.CompanyNameShort + ' \n', fontSize: 10, bold: true },
                  { text: (this.comp.CompanyStreet ? this.comp.CompanyStreet : ' ') + ' ' + (this.comp.CompanyBuildingNameNumber ? this.comp.CompanyBuildingNameNumber : ' ') + ' \n', fontSize: 8 },
                  { text: (this.comp.CompanyPostcode ? this.comp.CompanyPostcode : ' ') + ' ' + (this.comp.CompanyCity ? this.comp.CompanyCity : ' ') + ' \n', fontSize: 8 },
                  { text: this.lang.VATID + (this.comp.CompanyVATID ? this.comp.CompanyVATID : ' '), fontSize: 8 }
                ]
              },
              {
                // % width
                width: '45%',
                text: [
                  { text:  'Partneri - otvorene stavke\n', fontSize: 18, bold: true },
                  { text: ' Od konta : ' + this.card.fromAccount , fontSize: 8},
                  { text: ' Do konta : ' + this.card.toAccount+ '\n', fontSize: 8},
                  { text: ' Od datuma: ' + dayjs(this.card.docFromDate).format('DD.MM.YYYY')  + ' Do datuma: ' + dayjs(this.card.docToDate).format('DD.MM.YYYY'), fontSize:8}
                ]   
              },
              {
                // % width
                width: '20%',
                text: [                 
                  { text: ' Datum ispisa: ' + dayjs().format('DD.MM.YYYY, h:mm:ss a'), fontSize:8}
                ]   
              }

            ],
            // optional space between columns
            columnGap: 10
          }
        this.content.push(docPart)
    },
    addItemsHeader () {
        const docPart = {
        columns: [
              {
                width: '7%',
                fontSize: 8,
                alignment: 'left',
                text: this.lang.detailId
              },
              {
                width: '9%',
                fontSize: 8,
                alignment: 'left',
                text: this.lang.Account4
              },
              {
                width: '25%',
                fontSize: 8,
                alignment: 'left',
                text: this.lang.PartnerName
              },
              {
                width: '9%',
                fontSize: 8,
                alignment: 'left',
                text: this.lang.PartnerVATID
              },
              {
                width: '9%',
                fontSize: 8,
                alignment: 'right',
                text: this.lang.Total30
              },
              {
                width: '9%',
                fontSize: 7,
                alignment: 'right',
                text: this.lang.Total60
              },
              {
                width: '9%',
                fontSize: 7,
                alignment: 'right',
                text: this.lang.Total90
              },
              {
                width: '9%',
                fontSize: 7,
                alignment: 'right',
                text: this.lang.Total120
              },
              {
                width: '9%',
                fontSize: 7,
                alignment: 'right',
                text: this.lang.TotalOver
              },
            ]
          }
        this.content.push(docPart)        
    },
    addItems () {
           this.order = 0           
            if (this.card.items && this.card.items.length > 0) {
              this.card.items.map(item => {
                  this.order += 1
                      const docPart01 = {
                      columns: [
                            {
                              width: '7%',
                              fontSize: 8,
                              alignment: 'left',
                              text: item.line
                            },
                            {
                              width: '9%',
                              fontSize: 8,
                              alignment: 'left',
                              text: item.account4
                            },
                            {
                              width: '25%',
                              fontSize: 8,
                              alignment: 'left',
                              text: item.partnerName
                            },
                            {
                              width: '9%',
                              fontSize: 8,
                              alignment: 'left',
                              text: item.partnerVATID
                            },
                            {
                              width: '9%',
                              fontSize: 8,
                              alignment: 'right',
                              text: this.formatPrice(item.Total30)
                            },
                            {
                              width: '9%',
                              fontSize: 7,
                              alignment: 'right',
                              text: this.formatPrice(item.Total60)
                            },
                            {
                              width: '9%',
                              fontSize: 7,
                              alignment: 'right',
                              text: this.formatPrice(item.Total90)
                            },
                            {
                              width: '9%',
                              fontSize: 7,
                              alignment: 'right',
                              text: this.formatPrice(item.Total120)
                            },
                            {
                              width: '9%',
                              fontSize: 7,
                              alignment: 'right',
                              text:this.formatPrice(item.TotalOver)
                            },

                          ]
                        }
                      this.content.push(docPart01)
                }
              )
          }
    },
    addItemsFoter () {
       
      this.addLine()

      const docPart01 = {
           columns: [
              {
                width: '7%',
                fontSize: 8,
                alignment: 'left',
                text: ''
              },
              {
                width: '9%',
                fontSize: 8,
                alignment: 'left',
                text:''
              },
              {
                width: '25%',
                fontSize: 8,
                alignment: 'left',
                text: ''
              },
              {
                width: '9%',
                fontSize: 8,
                alignment: 'left',
                text: 'Ukupno:'
              },
              {
                width: '9%',
                fontSize: 8,
                alignment: 'right',
                text: this.formatPrice(this.card.Total30)
              },
              {
                width: '9%',
                fontSize: 7,
                alignment: 'right',
                text: this.formatPrice(this.card.Total60)
              },
              {
                width: '9%',
                fontSize: 7,
                alignment: 'right',
                text: this.formatPrice(this.card.Total90)
              },
              {
                width: '9%',
                fontSize: 7,
                alignment: 'right',
                text: this.formatPrice(this.card.Total120)
              },
              {
                width: '9%',
                fontSize: 7,
                alignment: 'right',
                text:this.formatPrice(this.card.TotalOver)
              }
          ]
        }
      this.content.push(docPart01)
    },
  },
  computed: {
  },
  watch: {
  },
  components: {
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slide-fade-enter-active {
  transition: all 1.3s ease;
}
.slide-fade-leave-active {
  transition: all 1.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>